  const CART_ATTRIBUTE_KEY = 'branch_verifone_id';
  const BRANCH_SELECTED_TEXT = window.themeVariables?.strings?.deliveryBranchSelected || '';
  const DELIVERY_DATE_TEXT = window.themeVariables?.strings?.deliveryDate || '';
  const PICKUP_PREFIX = window.themeVariables?.strings?.deliveryPickupPrefix || '';
  const DELIVERY_PREFIX = window.themeVariables?.strings?.deliveryDeliveryPrefix || '';
  const DELIVERY_TYPE = {
    delivery: 'delivery',
    pickup: 'pickup',
    hospital: 'hospital',
  };

  let branchMetaobjects = [];
  let currentBranchHandle = null;
  let currentDeliveryDate = null;
  let currentAddressType = null;
  let currentHospitalName = null;
  let currentPrivateAddressCity = null;
  let deliverySelectorButton = null;
  let hasCompletedInitialSync = false;
  
  document.documentElement.addEventListener('cart:updated', handleCartUpdate);
  document.documentElement.addEventListener('cart:refresh', handleCartUpdate);
  
  function onReady() {
    loadBranchMetaobjects();
    checkAndShowNotification();
    initDeliverySelectorButton();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  function initDeliverySelectorButton(retryCount = 0) {
    deliverySelectorButton = document.querySelector('.delivery-selector__banner');
    if (deliverySelectorButton) {
      deliverySelectorButton.addEventListener('click', () => {
        window.boaBranchPicker.open();
      });
      const addressType = deliverySelectorButton?.dataset?.addressType;
      setInitialState(deliverySelectorButton, addressType);
      return;
    }

    if (retryCount < 10) {
      setTimeout(() => initDeliverySelectorButton(retryCount + 1), 200);
    }
  }
  
  function formatDateToDDMMYYYY(dateString) {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      return dateString;
    }
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  function findBranchByVerifoneId(branches, verifoneId) {
    return branches.find((branchItem) => {
      return branchItem.verifone_id === verifoneId;
    });
  }

  function getDeliverySelectorElements(button) {
    const container = button.closest('.delivery-selector');
    if (!container) {
      return null;
    }
    return {
      button,
      container,
      selectedText: button.querySelector('.delivery-selector__selected-text'),
      selectedInfo: button.querySelector('.delivery-selector__selected-info'),
      defaultText: button.querySelector('.delivery-selector__text'),
      hintDefault: container.querySelector('.delivery-selector__hint-default'),
      hintSelected: container.querySelector('.delivery-selector__hint-selected'),
      hint: container.querySelector('.delivery-selector__hint'),
      chevronRight: button.querySelector('.delivery-selector__chevron--right'),
      chevronLeft: button.querySelector('.delivery-selector__chevron--left'),
    };
  }

  function buildDeliveryText(branchData, deliveryDate, addressType, hospitalName, privateAddressCity) {
    if (!branchData || !deliveryDate) {
      return '';
    }
    const formattedDate = formatDateToDDMMYYYY(deliveryDate);
    let displayName;

    const isHospital = addressType === DELIVERY_TYPE.hospital && hospitalName;
    const isDelivery = addressType === DELIVERY_TYPE.delivery && privateAddressCity;

    if (isHospital) {
      displayName = hospitalName;
    } else if (isDelivery) {
      displayName = privateAddressCity;
    } else {
      displayName = branchData.branch_name;
    }

    const prefix = (addressType === DELIVERY_TYPE.pickup) 
      ? PICKUP_PREFIX 
      : DELIVERY_PREFIX;

    const locationText = (addressType === DELIVERY_TYPE.pickup)
      ? BRANCH_SELECTED_TEXT.replace('@branch_name@', displayName)
      : displayName;
 
    const dateText = deliveryDate 
      ? `${prefix} ${DELIVERY_DATE_TEXT.replace('@delivery_date@', formattedDate)}`
      : '';

    return dateText ? `${dateText} ${locationText}` : locationText;
  }

  function updateDeliverySelectorVisualState(elements) {
    if (!elements || !elements.selectedText) {
      return;
    }
    elements.button.classList.add('is-selected');
    elements.selectedInfo?.classList.add('is-visible');
    elements.selectedInfo?.classList.remove('is-hidden');
    elements.defaultText?.classList.add('is-hidden');
    elements.hintDefault?.classList.add('is-hidden');
    elements.hintSelected?.classList.add('is-visible');
    elements.hintSelected?.classList.remove('is-hidden');
    elements.hint?.classList.add('is-selected');
    const direction = window.themeVariables?.settings?.direction || 'ltr';
    if (direction === 'rtl') {
      elements.chevronRight?.classList.add('is-hidden');
      elements.chevronLeft?.classList.remove('is-hidden');
    } else {
      elements.chevronLeft?.classList.add('is-hidden');
      elements.chevronRight?.classList.remove('is-hidden');
    }
  }

  function processBranchDataAndUpdateUI(branchHandle, deliveryDate, addressType, hospitalName, privateAddressCity, shouldSaveToStorage, button) {
    if (!branchHandle) {
      return false;
    }

    const branchesScript = document.querySelector('script[data-branches]');
    if (!branchesScript) {
      return false;
    }

    const branches = JSON.parse(branchesScript.textContent);
    const branchData = findBranchByVerifoneId(branches, branchHandle);

    if (!branchData) {
      return false;
    }

    const elements = getDeliverySelectorElements(button);
    if (!elements || !elements.selectedText) {
      return false;
    }

    const deliveryText = buildDeliveryText(branchData, deliveryDate, addressType, hospitalName, privateAddressCity);
    elements.selectedText.textContent = deliveryText;
    updateDeliverySelectorVisualState(elements);

    if (shouldSaveToStorage) {
      sessionStorage.setItem('boa_delivery_selection', JSON.stringify({
        branchHandle: branchHandle,
        deliveryDate,
        addressType,
        hospitalName,
        privateAddressCity
      }));
    }

    return true;
  }
  
  function setInitialState(button, addressType) {
    button.classList.remove('js-loading');
    button.classList.add('js-ready');

    const storedData = sessionStorage.getItem('boa_delivery_selection');
    if (storedData && addressType && addressType.length) {
      const { branchHandle, deliveryDate, addressType, hospitalName, privateAddressCity } = JSON.parse(storedData);
      processBranchDataAndUpdateUI(branchHandle, deliveryDate, addressType, hospitalName, privateAddressCity, false, button);
    }
    
    fetch(`${window.themeVariables?.routes?.cartUrl || '/cart'}.js`)
      .then((response) => {
        if (!response.ok) {
          return null;
        }
        return response.json();
      })
      .then((cart) => {
        if (!cart || !cart.attributes) {
          sessionStorage.removeItem('boa_delivery_selection');
          return;
        }

        const attributes = extractCartAttributes(cart);

        if (isDeliveryDateExpired(attributes.deliveryDate)) {
          sessionStorage.removeItem('boa_delivery_selection');
          clearCartDeliveryDate();
          return;
        }

        if (!attributes.branchHandle || !attributes.deliveryDate) {
          sessionStorage.removeItem('boa_delivery_selection');
          if (cart.attributes.delivery_price) {
            clearCartDeliveryAttributes(false);
          }
          return;
        }

        processBranchDataAndUpdateUI(attributes.branchHandle, attributes.deliveryDate, attributes.addressType, attributes.hospitalName, attributes.privateAddressCity, true, button);
      })
      .catch(() => {
        return;
      });
  }

  function loadBranchMetaobjects() {
    if (branchMetaobjects && branchMetaobjects.length > 0) {
      return;
    }

    const scriptTag = document.querySelector('script[data-branches]');
    if (!scriptTag) {
      return;
    }
    const branchesArray = JSON.parse(scriptTag.textContent);
    branchMetaobjects = branchesArray;
  }

  function clearCartDeliveryAttributes(reloadPage = true) {
    const cartUrl = `${window.themeVariables?.routes?.cartUrl || '/cart'}/update.js`;
    return fetch(cartUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: {
        "address_type": "",
        "region_metaobject_id": "",
        "branch_verifone_id": "",
        "branch_metaobject_id": "",
        "delivery_time_frame": "",
        "previous_shipping_option_code": "",
        "branch_title": "",
        "delivery_date": "",
        "delivery_price": "",
        "zip_code": "",
        "is_special_date": "",
        "private_address_city": "",
        "private_address_address1": "",
        "hospital_name": "",
        "hospital_department": "",
        "hospital_building": "",
        "hospital_floor": ""
      } }),
    })
      .then((response) => response.json())
      .then((cart) => {
        if (reloadPage) {
          window.location.reload();
          return cart;
        }

        document.documentElement.dispatchEvent(
          new CustomEvent('cart:updated', { bubbles: true, detail: { cart } })
        );
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', { bubbles: true, detail: { cart } })
        );

        return cart;
      });
  }

  function clearCartDeliveryDate() {
    clearCartDeliveryAttributes(true);
  }

  function isDeliveryDateExpired(deliveryDate) {
    if (!deliveryDate){ 
      return false;
    }
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return new Date(deliveryDate) < today;
  }

  function clearState() {
    currentBranchHandle = null;
    currentDeliveryDate = null;
    currentAddressType = null;
    currentHospitalName = null;
    currentPrivateAddressCity = null;
  }

  function updateState(attributes) {
  if (attributes.branchHandle !== undefined) {
    currentBranchHandle = attributes.branchHandle;
  }
  if (attributes.deliveryDate !== undefined) {
    currentDeliveryDate = attributes.deliveryDate;
  }
  if (attributes.addressType !== undefined) {
    currentAddressType = attributes.addressType;
  }
  if (attributes.hospitalName !== undefined) {
    currentHospitalName = attributes.hospitalName;
  }
  if (attributes.privateAddressCity !== undefined) {
    currentPrivateAddressCity = attributes.privateAddressCity;
  }
}

  function detectStateChanges(attributes) {
    const branchChanged = attributes.branchHandle !== currentBranchHandle;
    const dateChanged = attributes.deliveryDate !== currentDeliveryDate;
    const addressTypeChanged = attributes.addressType !== currentAddressType;
    const hospitalNameChanged = attributes.hospitalName !== currentHospitalName;
    const privateAddressCityChanged = attributes.privateAddressCity !== currentPrivateAddressCity;
    
    return {
      branchChanged,
      dateChanged,
      addressTypeChanged,
      hospitalNameChanged,
      privateAddressCityChanged,
      hasChanges: branchChanged || dateChanged || addressTypeChanged || hospitalNameChanged || privateAddressCityChanged
    };
  }

  function handleCartUpdate(event) {
    const cart = event?.detail?.cart;

    if (cart?.attributes?.[CART_ATTRIBUTE_KEY]) {
      const attributes = extractCartAttributes(cart);

      if (!attributes.branchHandle) {
        return;
      }

      const changes = detectStateChanges(attributes);

      if (!changes.hasChanges) {
        return;
      }

      updateState(attributes);
      loadBranchMetaobjects();
      updateDeliverySelectorUI(attributes, {
        branchChanged: changes.branchChanged && hasCompletedInitialSync,
      });
      return;
    }

    if (cart) {
      clearState();
      displayPopup(null);
      return;
    }

    fetchCartAndCheck();
  }

  async function fetchCart() {
    try {
      const response = await fetch(`${window.themeVariables?.routes?.cartUrl || '/cart'}.js`);
      if (!response.ok) {
        return null;
      }
      const cart = await response.json();
      return cart;
    } catch {
      return null;
    }
  }

  function extractCartAttributes(cart) {
    if (!cart || !cart.attributes) {
      return {
        branchHandle: null,
        deliveryDate: null,
        addressType: null,
        hospitalName: null,
        privateAddressCity: null,
      };
    }
    return {
      branchHandle: cart.attributes[CART_ATTRIBUTE_KEY],
      deliveryDate: cart.attributes.delivery_date,
      addressType: cart.attributes.address_type,
      hospitalName: cart.attributes.hospital_name,
      privateAddressCity: cart.attributes.private_address_city,
    };
  }

  async function fetchCartAndCheck() {
    const cart = await fetchCart();
    if (!cart) {
      return;
    }
    
    const attributes = extractCartAttributes(cart);
    
    if (!attributes.branchHandle) {
      clearState();
      displayPopup(null);
      return;
    }

    const changes = detectStateChanges(attributes);
    
    if (!changes.hasChanges) {
      return;
    }
    
    
    updateState(attributes);
    updateDeliverySelectorUI(attributes, {
      branchChanged: changes.branchChanged && hasCompletedInitialSync,
    });
  }

  async function checkAndShowNotification() {
    const cart = await fetchCart();
    if (cart) {
      const attributes = extractCartAttributes(cart);
      updateState(attributes);
    }

    hasCompletedInitialSync = true;

    if (!currentBranchHandle || currentBranchHandle === '') {
      return;
    }

    updateDeliverySelectorUI({
      branchHandle: currentBranchHandle,
      deliveryDate: currentDeliveryDate,
      addressType: currentAddressType,
      hospitalName: currentHospitalName,
      privateAddressCity: currentPrivateAddressCity
    }, { branchChanged: false });
  }

  async function fetchBranchNotification(branchHandle) {
    if (!branchHandle) {
      return;
    }

    loadBranchMetaobjects();

    const branchData = findBranchByVerifoneId(branchMetaobjects, branchHandle);

    if (!branchData) {
      return;
    }

    const message = branchData.message;
    if (!message) {
      return;
    }

    const buttonText = getMetaobjectTextValue(branchData.message_button_text);
    const buttonUrl = getMetaobjectLinkUrl(branchData.message_button_url);
    const actionButton = buttonText && buttonUrl
      ? { text: buttonText, url: buttonUrl }
      : null;

    const discountLinkUrl = getMetaobjectLinkUrl(branchData.popup_link);
    const discountLinkText = branchData.popup_link?.text || '';
    const discountButton = discountLinkText && discountLinkUrl
      ? { text: discountLinkText, url: discountLinkUrl }
      : null;

    displayPopup(message, actionButton, discountButton);
  }

  function getMetaobjectTextValue(field) {
    if (!field) {
      return '';
    }

    if (typeof field === 'string') {
      return field.trim();
    }

    if (typeof field === 'object' && field.value != null) {
      return String(field.value).trim();
    }

    return '';
  }

  function getMetaobjectLinkUrl(field) {
    if (!field) {
      return '';
    }

    if (typeof field === 'string') {
      return field.trim();
    }

    if (typeof field === 'object' && field.url) {
      return String(field.url).trim();
    }

    return '';
  }

  function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  function formatMessage(message) {
    return escapeHtml(message).replace(/\n/g, '<br>');
  }

  function displayPopup(message, actionButton = null, discountButton = null) {
    const popup = document.getElementById('branch-notification-popup');
    if (!popup) {
      return;
    }

    const messageElement = popup.querySelector('.branch-notification-modal__message');
    const actionButtonElement = popup.querySelector('.branch-notification-modal__action-button');
    const discountButtonElement = popup.querySelector('.branch-notification-modal__discount-button');
    const closeButtonElement = popup.querySelector('.branch-notification-modal__buttons [data-action="close"]');
    if (!messageElement) {
      return;
    }

    if (!message) {
      messageElement.innerHTML = '';
      if (actionButtonElement) {
        actionButtonElement.hidden = true;
        actionButtonElement.removeAttribute('href');
        actionButtonElement.textContent = '';
      }
      if (discountButtonElement) {
        discountButtonElement.hidden = true;
        discountButtonElement.removeAttribute('href');
        discountButtonElement.textContent = '';
      }
      popup.open = false;
      return;
    }

    messageElement.innerHTML = formatMessage(message);

    const hasActionButton = Boolean(actionButton?.text && actionButton?.url);
    const hasDiscountButton = Boolean(discountButton?.text && discountButton?.url);
    const hasAnyButton = hasActionButton || hasDiscountButton;

    if (actionButtonElement) {
      if (hasActionButton) {
        actionButtonElement.href = actionButton.url;
        actionButtonElement.textContent = actionButton.text;
        actionButtonElement.hidden = false;
      } else {
        actionButtonElement.hidden = true;
        actionButtonElement.removeAttribute('href');
        actionButtonElement.textContent = '';
      }
    }

    if (discountButtonElement) {
      if (hasDiscountButton) {
        discountButtonElement.href = discountButton.url;
        discountButtonElement.textContent = discountButton.text;
        discountButtonElement.hidden = false;
      } else {
        discountButtonElement.hidden = true;
        discountButtonElement.removeAttribute('href');
        discountButtonElement.textContent = '';
      }
    }

    if (closeButtonElement) {
      closeButtonElement.classList.toggle('button--primary', !hasAnyButton);
      closeButtonElement.classList.toggle('button--secondary', hasAnyButton);
    }

    popup.open = true;
  }

  function updateDeliverySelectorUI(attributes, options = {}) {
    const { branchChanged = false } = options;
    
    loadBranchMetaobjects();
    
    const branchData = findBranchByVerifoneId(branchMetaobjects, attributes.branchHandle);
    if (!branchData) {
      return;
    }

    if (!deliverySelectorButton) {
      return;
    }

    const elements = getDeliverySelectorElements(deliverySelectorButton);
    if (!elements || !elements.selectedText) {
      return;
    }
    
    const deliveryText = buildDeliveryText(branchData, attributes.deliveryDate, attributes.addressType, attributes.hospitalName, attributes.privateAddressCity);
    elements.selectedText.textContent = deliveryText;

    sessionStorage.setItem('boa_delivery_selection', JSON.stringify({
      branchHandle: attributes.branchHandle,
      deliveryDate: attributes.deliveryDate,
      addressType: attributes.addressType,
      hospitalName: attributes.hospitalName,
      privateAddressCity: attributes.privateAddressCity
    }));

    updateDeliverySelectorVisualState(elements);

    if (branchChanged) {
      fetchBranchNotification(attributes.branchHandle);
    }
  }
 
